export default __webpack_public_path__ + "static/media/pieGraphick_fake.f6a6fa15.png";